// Reads the new session id out of Bifrost's reschedule response body.
//
// Bifrost applies a `camelCaseResHandler` middleware to all JSON responses
// (see bifrost/src/middleware/camel-case-response.ts), so what reaches Lotus
// is `{ sessionId: number, ... }` even though the underlying Glepnir contract
// is snake_case.
//
// Returns undefined when the body is missing or does not match — the caller
// treats the id as best-effort metadata for native postMessage analytics.
//
// Note: POST /coaching-session/create currently returns 201 with no body
// (res.sendStatus(201)), so this util only produces a value for reschedule.
export const extractSessionId = (body: unknown): number | undefined => {
  if (
    body &&
    typeof body === "object" &&
    typeof (body as Record<string, unknown>).sessionId === "number"
  ) {
    return (body as { sessionId: number }).sessionId;
  }

  return undefined;
};
